import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { shufflePassword } from "../../utils/util";
import AsyncLocalStorage from "../../utils/AsyncLocalStorage";
import { useRecoilState, useRecoilValue } from "recoil";
import { langState, langText } from "../../recoil/lang";
import ApiController from "../../controller/ApiController";
import { qrAuthState, qrAuthType } from "../../recoil/auth";
import { orderDetailRealmType } from "../../recoil/type";
import { cartState } from "../../recoil/cart";
import { useToast } from "../../controller/ToastController";

const Password = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { ccard, order_data } = location.state;

  const showToast = useToast();

  const auth = useRecoilValue<qrAuthType>(qrAuthState);
  const [lang, setLang] = useRecoilState<number>(langState);

  const [cart, setCart] = useRecoilState<orderDetailRealmType[]>(cartState);

  const [password, setPassword] = useState<string>("");
  const [checkedPassword, setCheckedPassword] = useState<string>("");
  const [isInitial, setIsInitial] = useState<boolean>(false);
  const [isResetting, setIsResetting] = useState<boolean>(false);

  const [randomArray, setRandomArray] = useState<number[]>([]);

  const updatePassword = async () => {
    try {
      const res = await ApiController.user.setPaymentPassword(
        auth.client_user_id,
        password
      );
      if (res.data) {
        console.log("setPaymentPassword res", res.data);
        if (res.data.success) {
          showToast("비밀번호를 설정했어요.");
          setIsInitial(false);
          setIsResetting(false);
        } else {
          showToast("비밀번호 설정 오류가 발생했어요.", "error");
        }
      }
    } catch (err) {
      console.log("setPaymentPassword err-->", err);
    }
  };

  const checkPassword = async () => {
    try {
      const res = await ApiController.user.checkPayment(auth.client_user_id);
      console.log("checkPassword res", res.data);

      if (res && res.data.success) {
        setIsInitial(true);
        setIsResetting(true);
      }
    } catch (err) {
      console.log("checkPassword err-->", err);
    }
  };

  // // 결제
  const billingOrder = async () => {
    try {
      const res = await ApiController.user.billing(
        ccard.ccard_id,
        order_data.order_id,
        order_data.order_seq,
        auth.client_user_id,
        password
      );
      if (res) {
        setPassword("");
        if (res.data.success) {
          showToast("결제가 완료되었어요");
          setCart([]);
          AsyncLocalStorage.removeItem("cart");
          navigate(`/status`);
        } else {
          showToast("비밀번호가 일치하지 않아요.", "error");
          navigate(-1);
        }
      }
    } catch (err) {
      console.log("getNewOrder err-->", err);
    }
  };

  const resetting = () => {
    if (isInitial) {
      showToast("최초 비밀번호 설정이 필요해요", "error");
    } else {
      setPassword("");
      setCheckedPassword("");
      setIsResetting(!isResetting);
    }
  };

  const onClickPassword = (value: number) => {
    if (password.length === 6 && isResetting && checkedPassword.length < 6)
      setCheckedPassword(checkedPassword + value);
    else if (password.length < 6) setPassword(password + value);
  };
  const submitPassword = async () => {
    if (isResetting) {
      if (checkedPassword.length === 6) {
        if (password === checkedPassword) {
          await updatePassword();
        } else showToast("비밀번호가 일치하지 않아요.", "error");
        setPassword("");
        setCheckedPassword("");
      }
    } else {
      await billingOrder();
    }
  };

  const backspacePassword = () => {
    if (password.length === 6 && isResetting)
      setCheckedPassword(checkedPassword.slice(0, -1));
    else setPassword(password.slice(0, -1));
  };
  const resetPassword = () => {
    if (password.length === 6 && isResetting) setCheckedPassword("");
    else setPassword("");
  };

  useEffect(() => {
    setRandomArray(shufflePassword());
    checkPassword();
  }, []);

  useEffect(() => {
    if (password.length === 6) {
      submitPassword();
    }
  }, [password, checkedPassword, isResetting]);

  const RenderPassword = () => {
    const passwordCheck = () => {
      if (isResetting && password.length === 6) return checkedPassword;
      return password;
    };
    const passwordLengthCheck = () => {
      if (isResetting && password.length === 6) return checkedPassword.length;
      return password.length;
    };
    return (
      <div className="passwordWrap">
        {Array.from(passwordCheck()).map((_, index: number) => (
          <div key={index} className="password" />
        ))}
        {Array(6 - passwordLengthCheck())
          .fill(null)
          .map((_, index: number) => (
            <div key={index} className="password inactive" />
          ))}
      </div>
    );
  };
  const RenderNumberPad = () => {
    return (
      <div className="numberPadWrap">
        {randomArray.map((item: number, index: number) =>
          randomArray.length - 1 === index ? (
            <>
              <button className="numberSource clear" onClick={resetPassword}>
                <h4>{langText.password_button_delete_all[lang]}</h4>
              </button>
              <button
                className="numberSource"
                onClick={() => onClickPassword(item)}
              >
                <h3>{item}</h3>
              </button>
              <button className="numberSource" onClick={backspacePassword}>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_backspace.svg`}
                  alt="ic"
                />
              </button>
            </>
          ) : (
            <button
              key={index}
              className="numberSource"
              onClick={() => onClickPassword(item)}
            >
              <h3>{item}</h3>
            </button>
          )
        )}
      </div>
    );
  };

  return (
    <Style>
      <div className="knockContainer">
        <div className="header">
          <h3> </h3>
          <img
            className="backIcon"
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
            onClick={() => navigate(-1)}
            alt="back"
          />
        </div>
        <div className="titleWrap">
          <h3>
            {isResetting && password.length === 6
              ? langText.password_title_reset_check[lang]
              : `${
                  isResetting
                    ? langText.password_title_reset_password[lang]
                    : langText.password_title_password[lang]
                }`}
          </h3>
          <RenderPassword />
          <div className="row" onClick={resetting}>
            <h5>{langText.password_reset_password[lang]}</h5>
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left_grey.svg`}
              alt="ic"
            />
          </div>
        </div>
        <RenderNumberPad />
      </div>
    </Style>
  );
};
export default Password;

const Style = styled.div`
  .knockContainer {
    height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #000;
  }

  .header {
    padding: 20px 10px;
    text-align: center;
    position: relative;

    h3 {
      font-weight: 500;
    }
    .backIcon {
      position: absolute;
      left: 4px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .titleWrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding: 10px 0;

    h3 {
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
    }
    .row {
      display: flex;
      align-items: center;
      gap: 14px;

      h5 {
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        color: #7e8081;
      }
      img {
        height: 12px;
      }
    }
  }

  .passwordWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
    gap: 20px;
    .password {
      width: 14px;
      height: 14px;
      border-radius: 50px;
      background: #4dd2ae;
    }
    .password.inactive {
      background: #d9d9d9;
    }
  }

  .numberPadWrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    height: 50%;
    padding: 30px 10px 40px 10px;
    background: #4dd2ae;
    .numberSource {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(100% / 3);
      height: 25%;
      h3 {
        font-size: 24px;
        line-height: 28px;
        font-weight: 600;
      }
      h4 {
        font-size: 16px;
        line-height: 28px;
        font-weight: 600;
      }
      img {
        height: 26px;
      }
    }
  }
`;
